import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    if (typeof window === 'undefined') {
      return;
    }

    /**
     * SEO URL Recovery with loop guard:
     * Only redirect to a static .html file when the path is NOT an Angular
     * route, has no extension, and the .html artifact verifiably exists
     * (HEAD check). A session guard prevents infinite 404 reload loops on
     * direct nested URLs (/markets/:pair, /balances) and invalid paths.
     */
    const rawPath = window.location.pathname;
    const path = rawPath.endsWith('/') && rawPath !== '/' ? rawPath.slice(0, -1) : rawPath;

    const appRoutePrefixes = [
      '/login', '/signup', '/register', '/markets', '/balances',
      '/history', '/settings', '/profile', '/account', '/support',
      '/unavailable', '/response', '/redirect', '/callback',
      '/verificationwizard', '/verificationlevelzeroupdatedialog',
      '/autologoutdialog', '/403', '/404', '/terms', '/about',
      '/fees', '/api', '/security', '/bounty', '/legal', '/privacy',
      '/amlkyc', '/risk', '/earn', '/refer', '/coins'
    ];
    const isAppRoute = appRoutePrefixes.some(p => path === p || path.startsWith(p + '/'));

    const lastSegment = path.split('/').pop() || '';
    const hasExtension = lastSegment.includes('.');

    if (isAppRoute || hasExtension || path.endsWith('.html') || path === '/') {
      return;
    }

    // Loop guard: never attempt the same redirect twice in one session.
    const guardKey = `404_REDIRECT_TRIED:${path}`;
    try {
      if (sessionStorage.getItem(guardKey)) {
        return;
      }
      sessionStorage.setItem(guardKey, '1');
    } catch {
      return;
    }

    const { search, hash } = window.location;
    const htmlUrl = `${path}.html${search}${hash}`;
    // Verify the static file exists before leaving the SPA; otherwise
    // render a single stable 404 page.
    fetch(`${path}.html`, { method: 'HEAD' }).then(
      (res) => {
        if (res && res.ok) {
          window.location.replace(htmlUrl);
        }
      },
      () => {
        // Network/HEAD failure: stay on the 404 component.
      }
    );
  }

}
